import React, { useState, useContext, useEffect } from 'react';
import { gql, useQuery, useApolloClient } from '@apollo/client';
import useLatLng from './use-latlng';
import ProductPageContext from '../../contexts/ProductPageContext';
import OmniWdgetContent from './OmniWdgetContent';
import FindAStoreModal from '../FindAStoreModal/FindAStoreModal';

const query = gql`
  query Omni($latlng: LatLng, $qualifiedSku: String) {
    omni(latlng: $latlng, qualifiedSku: $qualifiedSku) {
      geolocateOnLoad
      store {
        brand
        city
        latitude
        longitude
        showLogo
        storeId
        storeLocator
        name
        zipCode
        inventory
        popinsEligibility
        fisEligibility
      }
    }
  }
`;

export default function OmniWidget() {
  const ProductPageState = useContext(ProductPageContext);
  const [omniAttributes, setOmniAttributes] = useState({});
  const [openFindAStoreModal, setFindAStoreModalOpen] = useState(false);

  const latlng = useLatLng(omniAttributes.geolocateOnLoad);
  const client = useApolloClient();
  const { data, previousData } = useQuery(query, {
    ssr: false,
    variables: { latlng, qualifiedSku: ProductPageState.collectionData.qualifiedSku },
    client,
  });

  const queryData = data || previousData;

  useEffect(() => {
    setOmniAttributes({
      geolocateOnLoad: queryData?.omni?.geolocateOnLoad,
    });
  }, [queryData?.omni?.geolocateOnLoad]);

  return (
    <div data-testid="omni-widget">
      <OmniWdgetContent
        selectedStore={queryData?.omni?.store}
        activeProduct={ProductPageState.collectionData?.activeProduct}
        sku={ProductPageState.collectionData?.qualifiedSku}
        eSpotContentData={ProductPageState.eSpotContent}
        setFindAStoreModalOpen={setFindAStoreModalOpen}
      />
      {openFindAStoreModal && (
      <FindAStoreModal
        openFindAStoreModal={openFindAStoreModal}
        setFindAStoreModalOpen={setFindAStoreModalOpen}
        selectedSku={ProductPageState.collectionData?.qualifiedSku}
      />
      )}
    </div>
  );
}
